import React from 'react'

import { Filters } from './Filters'
import { List } from './List'
import * as S from './templates.styles'

export const Templates = () => {
    return (
        <S.TemplatesWrapper>
            <Filters />

            <S.Content>
                <S.Header>
                    <S.Title>Survey Template(s)</S.Title>
                </S.Header>

                <List />
            </S.Content>
        </S.TemplatesWrapper>
    )
}
